import { makeStyles } from "@material-ui/core/styles";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";
import DeleteIcon from "@material-ui/icons/Delete";
import FavoriteIcon from "@material-ui/icons/Favorite";
import FavoriteBorderIcon from "@material-ui/icons/FavoriteBorder";
import { changeAppState } from "../../../../../../../../../../common/appState";
import { MuteUserOutlinedIcon } from "../../../../../../../../../../icon/MuteUserOutlinedIcon";
import { fetchSetMuteStatus } from "../../../../../../../../Message/MessagePanel/components/fetchSetMuteStatus";
import { User } from "../../../../../../../../User/types";
import { PostComment } from "../../../../../types";

export function CommentLowerButtonArea({
    comment,
    user,
    tmpMutedUserIds,
    setTmpMutedUserIds,
    isMyComment,
    hasOwnLike,
    deleteComment,
    likeComment,
    unlikeComment,
    likeCount,
    commentCount,
}: {
    comment: PostComment;
    user?: User;
    tmpMutedUserIds: number[];
    setTmpMutedUserIds: (ids: number[]) => void;
    isMyComment: boolean;
    hasOwnLike: boolean;
    deleteComment: () => void;
    likeComment: () => void;
    unlikeComment: () => void;
    likeCount: number;
    commentCount: number;
}) {
    const c = useCommentLowerButtonAreaStyles();
    return (
        <div className={c.container}>
            <div className={c.comment}>
                <ChatBubbleOutlineIcon />
                {commentCount > 0 && commentCount.toLocaleString()}
            </div>

            <LikeButton
                likeComment={likeComment}
                unlikeComment={unlikeComment}
                hasOwnLike={hasOwnLike}
                likeCount={likeCount}
            />

            {isMyComment ? (
                <div
                    className={c.delete}
                    onClick={ev => {
                        ev.stopPropagation();
                        deleteComment();
                    }}
                >
                    <DeleteIcon />
                </div>
            ) : (
                <div
                    className={c.mute}
                    onClick={ev => {
                        ev.stopPropagation();
                        if (!user) {
                            changeAppState("signInPanelState", {
                                type: "signUp",
                            });
                            return;
                        }
                        setTmpMutedUserIds(
                            tmpMutedUserIds.concat(comment.commentedUserId)
                        );
                        fetchSetMuteStatus(
                            user.userId,
                            comment.commentedUserId,
                            true
                        );
                    }}
                >
                    <MuteUserOutlinedIcon />
                </div>
            )}
        </div>
    );
}
const useCommentLowerButtonAreaStyles = makeStyles(theme => ({
    container: {
        display: "flex",
        justifyContent: "space-between",
        color: theme.palette.grey[700],
        fontSize: "small",
        paddingRight: 5,
    },
    comment: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
    },
    delete: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
    },
    mute: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
    },
}));

function LikeButton({
    hasOwnLike,
    likeComment,
    unlikeComment,
    likeCount,
}: {
    hasOwnLike: boolean;
    likeComment: () => void;
    unlikeComment: () => void;
    likeCount: number;
}) {
    const c = useLikeButtonStyles();
    return (
        <div
            className={c.container}
            onClick={ev => {
                ev.stopPropagation();
                if (hasOwnLike) {
                    unlikeComment();
                    return;
                }
                likeComment();
            }}
        >
            {hasOwnLike ? (
                <FavoriteIcon className={c.favorite} />
            ) : (
                <FavoriteBorderIcon />
            )}
            {likeCount > 0 && likeCount.toLocaleString()}
        </div>
    );
}
const useLikeButtonStyles = makeStyles({
    container: {
        display: "flex",
        alignItems: "center",
        cursor: "pointer",
    },
    favorite: { color: "red" },
});
